import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { Location } from "@angular/common";
import { CoreLogService } from "../../services/log.service";
import { Router, ActivatedRoute } from "@angular/router";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { CoreLanguageService } from "../../services/language.service";
import { FormControl } from "@angular/forms";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs/Subscription";
import { UserHelperService } from "../../services/userHelper.service";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { UserProfileService } from "../userProfile/userprofile.service";
import { IOSHelperService } from "../../services/IOSHelper.service";
import Utils from "../../shared/utils";
import { WebShopService } from "../../services/webShop.service";
import { forbiddenNameValidator, ValidatorsConfig } from "../../shared/validator/validator.function";
import { RouterHelperService } from "../../services/routerHelper.service";
import { FieldName } from "../../shared/validator/validatorMessage.interface";
import { INHOUSE_GROUPORDER_NAME_ERROR_MESSAGES } from "../../shared/validator/validatorErrorMessages";

@Component({
  selector: "inHouseUserNameRequest",
  templateUrl: "./inHouseUserNameRequest.component.html",
  styleUrls: ["./inHouseUserNameRequest.component.scss"],
  providers: [OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class inHouseUserNameRequestComponent implements OnInit, OnDestroy {

  private _langSubscriber: Subscription;
  private _userNameInputSubscriber: Subscription;
  private _userNamevalidationSubscriber: Subscription;
  private tableQrCode: string;
  public inputUserNickname: string = "";
  public isLogin: boolean = false;
  public isSmallView: boolean = false;
  public field = FieldName;

  /** Validate user input*/
  public usernameInputControl = new FormControl('', {
    validators: ValidatorsConfig.forGroupMemberName(),
    asyncValidators: forbiddenNameValidator(this._webShopService),
  });

  constructor(private _userHelperService: UserHelperService
    , private _location: Location
    , private _webShopService: WebShopService
    , private _userProfileService: UserProfileService
    , private _router: Router
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _mainnavService: MainnavService
    , private internationalisationService: InternationalisationService
    , private _iosHelperService: IOSHelperService
    , private _activatedRoute: ActivatedRoute
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _routerHelperService: RouterHelperService
  ) {
    this.isSmallView = this._mainnavService.viewType === ViewType.Small;
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("inHouseUserNameRequestComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;

    me.tableQrCode = null;
    const routeTargetData = me._activatedRoute.snapshot.data["routeTargetData"];
    if (routeTargetData) {
      me.tableQrCode = routeTargetData["tablecode"];
    }

    if (!me.tableQrCode) {
      me._coreLogService.error("inHouseUserNameRequestComponent.ngOnInit", "no tableQrCode");
      me._router.navigate(["/"]); // back to home
      return; // exit here
    }

    me._langSubscriber = me.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });
    me._userNamevalidationSubscriber = me.usernameInputControl.statusChanges.subscribe(() => {
      me.PushChanges();
    });
    me._userNameInputSubscriber = me.usernameInputControl.valueChanges.subscribe(() => {
      me.inputUserNickname = me.usernameInputControl.value;
      me.usernameInputControl.markAsTouched();
    });
    me.GetUserProfileName();

  }
  /** Get user name and set*/
  public GetUserProfileName(): string {
    const me = this;
    me.isLogin = me._userHelperService.IsRegistered;
    me.inputUserNickname = me.usernameInputControl.value;
    if (me.isLogin) {
      me._userProfileService.GetUserInfoViewModel()
        .then(async (userViewModel) => {
          me.inputUserNickname = userViewModel.fname;
          me.usernameInputControl.setValue(me.inputUserNickname);
          me.PushChanges();
        })
        .catch(e => {
          me._coreLogService.error("inHouseUserNameRequestComponent.GetUserProfileName", "GetUserInfoViewModel", e);
        });
    } else {
      me.inputUserNickname = "";
    }
    return me.inputUserNickname;
  }

  public setUserName(): string {
    const me = this;
    if (Utils.IsNullOrEmpty(me.inputUserNickname)) {
      me.inputUserNickname = me.usernameInputControl.value;
    }
    return me.inputUserNickname;
  }

  public get inputPlaceholder(): string {
    const me = this;
    return me._coreLanguageService.value("phInHouse_UseName_Request_InputPh")
  }

  /** Get active error message for a form control based on field type */
  public activeError(control: FormControl, fieldName: FieldName): string | null {
    return ValidatorsConfig.getActiveErrorMessage(control, INHOUSE_GROUPORDER_NAME_ERROR_MESSAGES, fieldName);
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  /** navigate back on swipe from left to right */
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }

  /** navigate back */
  public navigateBack(): void {
    const me = this;
    const previousUrl = me._routerHelperService.getPreviousUrl();
    if (previousUrl && previousUrl.includes("orderModeSelector")) {
      me._routerHelperService.setRouteTargetDataByKey("tablecode", me.tableQrCode);
    }
    me._location.back();
  }

  public NavigateToLandingPage() {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._webShopService.submitTableCodeData(me.tableQrCode, me.setUserName()).then(() => {
      me._overlaySpinnerService.HideLayoutSpinner();
    }).catch((error) => {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._coreLogService.error("inHouseUserNameRequestComponent.navigateToSingleOrder", "webShopService.submitQRCodeData(catch)", me.tableQrCode, error);
    });
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
    if (me._userNameInputSubscriber) {
      me._userNameInputSubscriber.unsubscribe();
    }
    if (me._userNamevalidationSubscriber) {
      me._userNamevalidationSubscriber.unsubscribe();
    }
  }
}
